import { SearchOutlined } from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
  notification,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { ColumnProps } from "types/models";
import { medicalExaminationService, employeeService } from "api";
import {
  gioiTinhOptions,
  trangThaiTheBNOptions,
} from "assets/constants/select-catagory-options";
import "./PatientCardManagement.scss";
import Icons from "assets/icons";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setActiveKey } from "redux/reducer/common";
import { tabKeys } from "types/enums";
import { RECEIVE_ACTION_TYPE } from "types/enums/receive-action-type";
import { setAction } from "redux/reducer/receive";
import { RefreshIconSVG } from "assets";
import { ListActionButton } from "components/common";
import Notification from "components/common/notification/notification";
import DetailCardInfo from "./DetailCardInfo/DetailCardInfo";
import { parseDatetime } from "helper/format-date";
import {
  convertIosDateToString,
  exportFile,
  formatDateToString,
  formatToCurrencyType,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import { STATUS_CARD } from "assets/constants/card-types";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { ColumnsEdit } from "types/models/column-table-edit";

const PatientCardManagement = () => {
  const detailRef = useRef<any>();

  const deleteFunc = async (record) => {
    try {
      const response = await medicalExaminationService.deletePatientCard({
        id: record.id,
      });
      Notification("success", "Xoá thành công!");
      fetchData();
    } catch (err) {}
  };

  const detailFunc = async (record) => {
    detailRef.current?.setData({ ...record });
    detailRef.current?.openModal();
  };

  const listPatientColumns: ColumnProps[] = [
    {
      title: "STT",
      key: "stt",
      dataIndex: "stt",
      align: "center",
      isResizable: true,
      show: true,
      render(value, record, index) {
        return <div>{index + 1}</div>;
      },
    },
    {
      title: "Mã bệnh nhân",
      key: "maBenhNhan",
      dataIndex: "maBenhNhan",
      align: "center",
      isResizable: true,
      show: true,
    },
    {
      title: "Tên trên thẻ",
      key: "hoTen",
      dataIndex: "hoTen",
      align: "left",
      isResizable: true,
      show: true,
    },
    {
      title: "Tên loại thẻ",
      key: "tenLoaiThe",
      dataIndex: "tenLoaiThe",
      align: "left",
      isResizable: true,
      show: true,
    },
    {
      title: "Giới tính",
      key: "gioiTinh",
      dataIndex: "gioiTinh",
      align: "center",
      render: (v) => {
        return gioiTinhOptions.find((it) => it.value === v)?.label || "";
      },
      isResizable: true,
      show: true,
    },
    {
      title: "Ngày sinh",
      dataIndex: "ngaySinh",
      key: "ngaySinh",
      align: "center",
      render: (v, r, idx) => {
        return v ? <>{dayjs(v).format("DD/MM/YYYY")}</> : null;
      },
      isResizable: true,
      show: true,
    },
    {
      title: "Số điện thoại",
      dataIndex: "dienThoai",
      key: "dienThoai",
      align: "left",
      isResizable: true,
      show: true,
    },
    {
      title: "Địa chỉ",
      dataIndex: "diaChiTongHop",
      key: "diaChiTongHop",
      align: "left",
      isResizable: true,
      show: true,
    },
    // {
    //   title: "Mã loại thẻ",
    //   dataIndex: "ma",
    //   key: "ma",
    //   align: "center",
    //   isResizable: true,
    // },
    {
      title: "Tên loại thẻ",
      dataIndex: "tenLoaiThe",
      key: "tenLoaiThe",
      align: "left",
      isResizable: true,
      show: true,
    },
    {
      title: "Người bán thẻ",
      dataIndex: "nguoiBan",
      key: "nguoiBan",
      align: "left",
      isResizable: true,
      show: true,
    },
    {
      title: "Ngày phát hành",
      dataIndex: "ngayPhatHanh",
      key: "ngayKetThuc",
      align: "center",
      render: (v, r, idx) => {
        return v ? <>{dayjs(v).format("DD/MM/YYYY")}</> : null;
      },
      isResizable: true,
      show: true,
    },
    {
      title: "Ngày hết hạn",
      dataIndex: "hetHan",
      key: "hetHan",
      align: "center",
      render: (v, r, idx) => {
        return v ? <>{dayjs(v).format("DD/MM/YYYY")}</> : null;
      },
      isResizable: true,
      show: true,
    },
    {
      title: "Trạng thái thẻ",
      dataIndex: "trangThai",
      key: "trangThai",
      align: "left",
      render: (v, r, idx) =>
        STATUS_CARD.find((it) => it.value === v)?.label || "",
      isResizable: true,
      show: true,
    },
    {
      title: "Số tiền",
      dataIndex: "giaBan",
      key: "giaBan",
      align: "right",
      render: (value, record, index) => {
        return <>{formatToCurrencyType(value)}</>;
      },
      isResizable: true,
      show: true,
    },
    {
      title: "Thao tác",
      key: "action",
      dataIndex: "action",
      fixed: "right",
      align: "center",
      render: (value, record, idx) => {
        return (
          <ListActionButton
            showDetailFunction={() => detailFunc(record)}
            deleteFunction={() => deleteFunc(record)}
          />
        );
      },
    },
  ];
  let savedTableOption = getTableOptions(
    "PATIENT_TABLE",
    localStorage.getItem("username")
  );

  const defaultColumns = savedTableOption
    ? listPatientColumns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : listPatientColumns;
  // state
  const action = useAppSelector((state) => state.receive);
  const [form] = Form.useForm();
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [columns, setColumns] = useState<ColumnsEdit>(
    defaultColumns.filter((e) => e.show == true)
  );
  const [searchValues, setSearchValues] = useState<any>({});
  const [isOpenDate, setIsOpenDate] = useState<boolean>(false);
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const [listEmployees, setListEmployees] = useState([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [total, setTotal] = useState();
  const activeTab = useAppSelector((e) => e.common.activeTab);

  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    end: dayjs(),
    start: dayjs(),
  });

  // functions
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await medicalExaminationService.getListPatientCard(
        formatParams()
      );
      setData(response.data);
      setTotal(response.data.total);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Lỗi xảy ra khi lấy dữ liệu thẻ bệnh nhân");
    }
  };

  const formatParams = () => {
    return {
      ...params,
      ngaySinh: formatDateToString(params.ngaySinh),
      start: formatDateToString(params.start),
      end: formatDateToString(params.end),
    };
  };

  useEffect(() => {
    getListEmployee();
  }, []);

  const getListEmployee = async () => {
    try {
      const response =
        (await employeeService.searchEmployee({
          page: 1,
          limit: 1000,
        })) || [];
      const newOption = response.items.map((e) => {
        return { value: e.hoTen, label: e.hoTen };
      });
      setListEmployees(newOption);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const onFinish = () => {
    const values = form.getFieldsValue();
    setParams({
      ...params,
      ...values,
      page: 1,
    });
  };

  const handleKeyPress = async (e, timeout?) => {
    if (e.key === "Enter") {
      await setTimeout(() => {
        setCurrentPage(1);
        onFinish();
      }, timeout ?? 100); // Gọi onFinish nếu Enter được nhấn
    }
  };
  const getExportFile = async () => {
    setLoading(true);
    try {
      exportFile(
        "/qlkhambenh/don-ban-the-kham/export-chi-tiet",
        formatParams(),
        "danh-sach-don-ban-the-kham"
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const clearFields = (e) => {
    setSearchValues({});
    form.resetFields();
  };

  useEffect(() => {
    fetchData();
  }, [params, activeTab]);
  // useEffect(() => {
  //   if (action.actionType === RECEIVE_ACTION_TYPE.REMOVE_PATIENT_CARD_ROW) {
  //     fetchData({
  //       ...searchValues,
  //       start:convertIosDateToString(data?.start),
  //       end:convertIosDateToString(data?.end),
  //       page: page,
  //       limit: limit,
  //     });
  //   }
  // }, [action]);
  // useEffect(() => {
  //   if (activeTab === tabKeys.RECEIVE.TAB_4) {
  //     fetchData({
  //       start:convertIosDateToString(data?.start),
  //       end:convertIosDateToString(data?.end),
  //       ...searchValues,
  //       page: page,
  //       limit: limit,
  //     });
  //   }
  // }, [activeTab]);

  useEffect(() => {}, [page, limit]);
  columns.map((it) => {
    if (it.dataIndex === "stt") {
      it.render = (v, r, i) => {
        return (params.page - 1) * params.limit + i + 1;
      };
    }
  });
  const handleOnPrint = () => {
    // console.log('list id in dich vu', listId);
    setIsShowModalPrint(true);
  };
  const onChangePagination = (page: number, pageSize: number) => {
    setCurrentPage(page);
    setParams({ ...params, page: page, limit: pageSize });
  };
  const setShowColumns = (showColumns) => {
    saveTableOptions(
      "PATIENT_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  return (
    <div className="patient-card-management">
      <div className="container" onKeyDown={handleKeyPress}>
        <Row>
          <Form
            form={form}
            labelAlign="left"
            initialValues={{
              start: dayjs(),
              end: dayjs(),
            }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={
                    <Typography.Text ellipsis>Mã bệnh nhân</Typography.Text>
                  }
                  name="idBenhNhan"
                  labelAlign="left"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <Input className="data-input-field" placeholder="Nhập" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={<Typography.Text ellipsis>Họ tên</Typography.Text>}
                  name="hoTen"
                  labelAlign="left"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <Input className="data-input-field" placeholder="Nhập" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={<Typography.Text ellipsis>Ngày sinh</Typography.Text>}
                  name="ngaySinh"
                  labelAlign="left"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <DatePicker
                    className="data-picker-field"
                    placeholder="DD/MM/YYYY"
                    format={isOpenDate ? "DDMMYYYY" : "DD/MM/YYYY"}
                    onOpenChange={() => setIsOpenDate(!isOpenDate)}
                    // onKeyDown={(e) => handleKeyPress(e, 500)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={
                    <Typography.Text ellipsis>Trạng thái thẻ</Typography.Text>
                  }
                  name="trangThai"
                  labelAlign="left"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <Select
                    className="data-select-field"
                    placeholder="Chọn"
                    options={trangThaiTheBNOptions}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={
                    <Typography.Text ellipsis>Người bán thẻ</Typography.Text>
                  }
                  name="nguoiBanThe"
                  labelAlign="left"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <Select
                    showSearch
                    allowClear
                    className="data-picker-field"
                    placeholder="Nhập"
                    options={listEmployees}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={
                    <Typography.Text ellipsis>Số điện thoại</Typography.Text>
                  }
                  name="dienThoai"
                  labelAlign="left"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <Input className="data-picker-field" placeholder="Nhập" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={
                    <Typography.Text ellipsis>
                      Ngày phát hành từ
                    </Typography.Text>
                  }
                  name="start"
                  labelAlign="left"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <DatePicker
                    className="data-picker-field"
                    placeholder="DD/MM/YYYY"
                    format={"DD/MM/YYYY"}
                    disabledDate={(current) => {
                      return current.isAfter(dayjs());
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={
                    <Typography.Text ellipsis>
                      Ngày phát hành đến
                    </Typography.Text>
                  }
                  name="end"
                  labelAlign="left"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <DatePicker
                    className="data-picker-field"
                    placeholder="DD/MM/YYYY"
                    format={"DD/MM/YYYY"}
                    disabledDate={(current) => {
                      return current.isAfter(dayjs());
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={
                    <Typography.Text ellipsis>Tên loại thẻ</Typography.Text>
                  }
                  name="tenLoaiThe"
                  labelAlign="left"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <Input className="data-input-field" placeholder="Nhập" />
                </Form.Item>
              </Col>
              <Row justify={"end"} style={{ gap: "4px" }}>
                <Form.Item>
                  <Button
                    className="btn-sub"
                    type="text"
                    icon={<RefreshIconSVG />}
                    onClick={clearFields}
                  >
                    Xóa tìm kiếm
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    className="custom-btn"
                    icon={<SearchOutlined />}
                    onClick={onFinish}
                  >
                    Tìm kiếm
                  </Button>
                </Form.Item>
              </Row>
            </Row>
          </Form>
        </Row>
      </div>
      <div className="container">
        <Row className="extend-table" gutter={[0, 8]}>
          <Row gutter={[16, 16]}>
            <Row justify={"end"} align={"middle"} style={{ gap: "4px" }}>
              <Space>
                <Button
                  type="text"
                  className="btn-sub"
                  icon={<Icons.printer />}
                  onClick={handleOnPrint}
                >
                  In phiếu thu lẻ
                </Button>
                <Button
                  icon={<Icons.file />}
                  type="primary"
                  className="custom-btn"
                  onClick={getExportFile}
                >
                  Xuất danh sách in thẻ
                </Button>
              </Space>
            </Row>
          </Row>
          <Row>
            <CustomResizableTable
              setShowColumns={setShowColumns}
              rowKey={(record) => record.id}
              columns={columns}
              dataSource={data.data}
              loading={loading}
              bordered
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,
                total: total,
                onChange: onChangePagination,
                current: currentPage,
                pageSize: params.limit,
              }}
            />
            <DetailCardInfo ref={detailRef} />
          </Row>
        </Row>
      </div>
    </div>
  );
};

export default PatientCardManagement;
